import { createAction, createActionGroup, props } from '@ngrx/store';
import { DisclosedDocumentDto } from '@shared/models/disclosed-document-dto';
import { Pageable } from '@shared/models/page-sort/pageable';
import { SearchCriteriaDto } from '@shared/models/search-criteria-dto';
import { Page } from '@shared/models/page-sort/page';

export const searchDocuments = createAction(
    '[Search Component] Search documents',
    props<{
        searchType: string,
        searchCriteria: SearchCriteriaDto,
        pageable: Pageable
    }>()
);

export const searchDocumentsApiActions = createActionGroup({
    source: 'Search Documents API',
    events: {
        searchSuccess: props<{ searchResults: Page<DisclosedDocumentDto> }>()
    }
});

export const loadPublishedDocument = createAction(
    '[Search Component] Load published document',
    props<{
        publishedDocumentId: number
    }>()
);

export const loadPublishedDocumentApiActions = createActionGroup({
    source: 'Load published document API',
    events: {
        loadSuccess: props<{ publishedDocumentDetail: DisclosedDocumentDto }>()
    }
});
